var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.agencyMsgStatus
        ? _c(
            "div",
            {
              staticClass: "alert alert-success text-left",
              attrs: { role: "alert" }
            },
            [
              _c(
                "span",
                {
                  staticClass: "font-weight-bold",
                  staticStyle: { "text-transform": "capitalize" }
                },
                [_vm._v(_vm._s(_vm.agencyName))]
              ),
              _vm._v(" has been created.\n  ")
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-head rounded-top py-2 px-0 no-gutters" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                { staticClass: "no-gutters" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-auto text-left",
                      attrs: { cols: "12", md: "4" }
                    },
                    [_vm._v("Agency List")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", md: "8" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass:
                            "search-box-admin mb-0 mt-sm-2 mt-md-0 float-md-right"
                        },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c(
                                "b-input-group-text",
                                { attrs: { slot: "prepend" }, slot: "prepend" },
                                [_c("i", { staticClass: "fas fa-search" })]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "search-text-box-admin",
                                attrs: { placeholder: "Search Table" },
                                model: {
                                  value: _vm.filter,
                                  callback: function($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "smaller-font-content",
        attrs: {
          hover: "",
          id: "manage-table",
          items: _vm.formartedItems,
          fields: _vm.fields,
          responsive: true,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          filter: _vm.filter,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          "sort-direction": _vm.sortDirection,
          "sort-compare": _vm.dateSortCompare,
          "primary-key": "agencyId"
        },
        on: {
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          },
          filtered: _vm.onFiltered
        },
        scopedSlots: _vm._u([
          {
            key: "agency",
            fn: function(data) {
              return _c("span", { domProps: { innerHTML: _vm._s(data.value) } })
            }
          },
          {
            key: "agencyAdmin",
            fn: function(data) {
              return _c("span", { domProps: { innerHTML: _vm._s(data.value) } })
            }
          },
          {
            key: "status",
            fn: function(data) {
              return _c("b-form-checkbox", {
                attrs: {
                  name: "check-button",
                  id: "agency-" + data.item.agencyId,
                  switch: ""
                },
                on: {
                  change: function($event) {
                    return _vm.toggleAll(data)
                  }
                },
                model: {
                  value: data.value,
                  callback: function($$v) {
                    _vm.$set(data, "value", $$v)
                  },
                  expression: "data.value"
                }
              })
            }
          },
          {
            key: "editAgency",
            fn: function(data) {
              return _c("span", { domProps: { innerHTML: _vm._s(data.value) } })
            }
          },
          {
            key: "products",
            fn: function(data) {
              return _c("span", { domProps: { innerHTML: _vm._s(data.value) } })
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { md: "6" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row no-gutters mb-3 head-container" }, [
      _c("div", { staticClass: "col-md-6 display-1" }, [
        _vm._v("Agency Manager")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-6 text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-success",
            attrs: { type: "button", id: "add-agency" }
          },
          [_vm._v("+Add Agency")]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03439fc8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03439fc8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/admin/agencies/AgencyManager.vue
// module id = null
// module chunks = 